<template>
    <b-modal
        v-model="modalShow"
        size="lg"
        title="お悩みを選択してください"
        ok-title="閉じる"
        ok-variant="yokumiru-gray"
        ok-only
        @ok="close"
        @hidden="close">
        <div class="modal-body">
            <div class="supportItemWrapper">
                <a
                    href="#"
                    target="_blank"
                    class="supportItem"
                    @click="onClickQuestion">
                    <ul>
                        <li>オンライン相談をするべき症状か、病院に行くべき症状か分からない</li>
                        <li>どの相談科を選べばよいか分からない</li>
                    </ul>
                </a>
                <a
                    href="#"
                    class="supportItem"
                    @click="onClickHowToConsultation">
                    <ul>
                        <li>オンライン相談の使い方に不安がある</li>
                    </ul>
                </a>
                <a
                    href="#"
                    target="_blank"
                    class="supportItem"
                    @click="onClickContact">
                    <ul>
                        <li>その他ご質問・ご要望、お問い合わせ</li>
                    </ul>
                </a>
            </div>
        </div>
    </b-modal>
</template>

<script>
    import YokumiruHelper from '../../../YokumiruHelper'

    export default {
        name: 'UserSupportModal',

        props: {
            user: {
                type: Object,
                required: true,
            },
            env: {
                type: String,
                required: true,
            },
        },

        data: function () {
            return {
                modalShow: false,
                helper: YokumiruHelper,
            }
        },

        computed: {
            formrunUrlQuestion: function () {
                const baseUrl = this.env === 'consul' ? 'https://form.run/@doctor-monshin' : 'https://form.run/@dev-staging-monshin'
                const query = `?_field_68=${this.user.id}&_field_22=${this.user.full_name}&_field_58=${this.user.email}`

                return encodeURI(`${baseUrl}${query}`)
            },

            formrunUrlContact: function () {
                const baseUrl = this.env === 'consul' ? 'https://yokumiru.jp/contact-kojin' : 'https://form.run/@dev-staging-contact-kojin'
                const query = `?_field_2=${this.user.full_name}&_field_9=${this.user.full_name_kana}&_field_1=${this.user.email}`

                return encodeURI(`${baseUrl}${query}`)
            },
        },

        created: function () {
            bus.$on('open-modal-user-support', this.open)
        },

        beforeDestroy: function () {
            bus.$off('open-modal-user-support')
        },

        methods: {
            /**
             * モーダル表示
             */
            open: function () {
                this.modalShow = true
            },

            /**
             * モーダル非表示
             */
            close: function () {
                this.modalShow = false
            },

            /**
             * 「オンライン相談をするべき症状か…」押下時
             */
            onClickQuestion: function (e) {
                e.preventDefault()
                this.pushAnalyticsDataLayer('オンライン相談をするべき症状か…')

                window.location.href = this.formrunUrlQuestion
            },

            /**
             * 「オンライン相談の使い方に不安がある」押下時
             */
            onClickHowToConsultation: function (e) {
                e.preventDefault()
                this.pushAnalyticsDataLayer('オンライン相談の使い方に不安がある')

                bus.$emit('on-click-how-to-consultation')
                this.close()
            },

            /**
             * 「その他ご質問・ご要望、お問い合わせ」押下時
             */
            onClickContact: function (e) {
                e.preventDefault()
                this.pushAnalyticsDataLayer('その他ご質問・ご要望、お問い合わせ')

                window.location.href = this.formrunUrlContact
            },

            /**
             * GoogleAnalytics GA4 カスタムイベント発火
             */
            pushAnalyticsDataLayer: function (supportType) {
                if (this.$locale.type !== 'consul') return

                window.dataLayer = window.dataLayer || []
                window.dataLayer.push({
                    event: 'dl__selectSupportType',
                    supportType: supportType,
                })
            },
        },
    }
</script>

<style scoped lang="scss">
.supportItemWrapper {
    .supportItem {
        display: block;
        margin: 15px 0;
        padding: 18px 15px;
        color: #2A2E31;
        font-weight: bold;
        background: #F8F8F8;
        box-shadow: 3px 3px 0 #dadada;
        border: 1px solid #ececec;
        border-radius: 8px;
        cursor: pointer;
        transition: all 0.2s ease-in-out;
        text-decoration: none;

        &:hover {
            color: #fff;
            background: #F77696;
            box-shadow: 3px 3px 0 #d5637f;
            border: 1px solid #F77696;
        }

        ul {
            margin-bottom: 0;
            padding-left: 24px;
        }
    }
}
</style>
